import { render, staticRenderFns } from "./points_record.vue?vue&type=template&id=910180c4&scoped=true&"
import script from "./points_record.vue?vue&type=script&lang=ts&"
export * from "./points_record.vue?vue&type=script&lang=ts&"
import style0 from "./points_record.vue?vue&type=style&index=0&id=910180c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910180c4",
  null
  
)

export default component.exports